<template>
  <layout title="Plans">
    <div class="flex justify-center">
      <div class="md:p-8 p-4 max-w-7xl w-full flex items-start">
        <sideMenu page="apikey" />
        <div class="flex-1 md:ml-8 ml-4">
          <div
            class="
              font-black
              text-3xl text-gray-800
              inline-block
              lg:col-span-2
              col-span-1
            "
          >
            Plans
          </div>
          <div
            class="mt-6 bg-white shadow-allArround rounded-xl flex-1 relative"
          >
            <div class="p-4 text-gray-800 overflow-hidden bg-gray-50">
              <prices :fromUser="true" :errors="errors" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </layout>
</template>

<script>
 
const layout = () =>
  import(/* webpackChunkName: "layout" */ "../../Components/Layout/layout.vue");
const sideMenu = () =>
  import(
    /* webpackChunkName: "sideMenu" */ "../../Components/Layout/User/sideMenu.vue"
  );
const prices = () =>
  import(
    /* webpackChunkName: "layout" */ "../../Components/Layout/Pricing/prices.vue"
  );

export default {
  components: { layout, sideMenu, prices },
  props: ["errors"],
};
</script>